import { connect } from "react-redux";

import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { AddRowButtonContainerProps } from "../AddRowButton/AddRowButtonContainer";
import { addInstance, LastInstanceBehaviour, removeInstance } from "../../../Engine/ActionCreators/AllActionCreators";

import { Multiple } from "./Multiple";

export interface MultiLineFieldContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: MultiLineFieldContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;
    const instances = viewModelSelect.children(state, bindingPath, ["0"]);

    return {
        instances: instances,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: AddRowButtonContainerProps) => ({
    onAddInstance: () => {
        dispatch(addInstance(ownProps.bindingPath));
    },
    onRemoveInstance: (bindingPath: AbsoluteResolvedModelPath, instancesToRemove: string) => {
        dispatch(removeInstance(bindingPath, instancesToRemove, LastInstanceBehaviour.Remove));
    },
});

export const MultipleContainer = withResolvePaths(
    withViewModelSelect(
        connect(mapStateToProps, mapDispatchToProps)(withControlDebugInfo(withTestPageObjectRegistration(Multiple)))
    )
);
